export class PoQtyGrnDtoReqDto {
    
    month: number;
    year: number;
    unitId: string;
    reportType: string;
}